import {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {EditorGroup} from '~/CreateFabricInvitation/components/EditorGroup/EditorGroup';
import {EditorHeader} from '~/CreateFabricInvitation/components/EditorHeader/EditorHeader';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {useOutsideAlerter} from '~/common/FabricInvitation/EventCreateDesign/hooks/useOutsideAlerter';
import {Button} from '~library/atoms/Button';

import './TextEditor.sass';

export const TextEditor = () => {
  const {canvas, activeObjects} = useContext(EventCreateContext);
  const [text, setText] = useState('');
  const activeObject = activeObjects?.[0];
  const disabled = activeObject?.type !== 'textbox';

  const textEditorRef = useRef(null);

  useEffect(() => {
    setText(activeObject?.text);
  }, [activeObject]);

  const changeText = useCallback(
    (value) => {
      setText(value);
      activeObject.set('text', value);
      canvas.requestRenderAll();
    },
    [activeObject, canvas]
  );

  const onTextEditingEntered = useCallback(({target}) => {
    target.hiddenTextarea.addEventListener('input', ({target: {value}}) => setText(value));
  }, []);

  useEffect(() => {
    const activeObj = canvas?.getActiveObject();
    if (!activeObj || activeObj.type !== 'textbox') {
      setText('');
    }

    canvas?.on({
      'text:editing:entered': onTextEditingEntered,
    });
    return () => {
      canvas?.off({
        'text:editing:entered': onTextEditingEntered,
      });
    };
  }, [canvas, onTextEditingEntered]);

  const onTextChangeHandler = useCallback(({target: {value}}) => changeText(value), [changeText]);

  const onClearClickHandler = () => changeText('');

  const handleFocus = (event) => event.target.select();

  const handleBlur = useCallback(() => {
    activeObject?.exitEditing?.();
  }, [activeObject]);

  useOutsideAlerter(textEditorRef, handleBlur);

  return (
    <EditorGroup className="desktop_editor__text_editor">
      <EditorHeader
        title="Text Editor"
        extra={
          <Button
            data-qa-id="step1-texteditor-clear"
            variant="link"
            size="small"
            onClick={onClearClickHandler}
            disabled={disabled}
            className="desktop_editor__text_editor__header__clear_btn"
          >
            Clear
          </Button>
        }
      />
      <div className="desktop_editor__text_editor__body">
        <textarea
          onFocus={handleFocus}
          onChange={onTextChangeHandler}
          value={disabled ? '' : text}
          data-qa-id="step1-texteditor-input"
          disabled={disabled}
          ref={textEditorRef}
        />
      </div>
    </EditorGroup>
  );
};
